import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "../../../server/routers";

type TrpcReact = ReturnType<typeof createTRPCReact<AppRouter>>;

// Ensure a single TRPC React instance across code-split bundles.
const globalForTrpc = globalThis as typeof globalThis & {
  __solmi_trpc__?: TrpcReact;
};

export const trpc =
  globalForTrpc.__solmi_trpc__ ?? (globalForTrpc.__solmi_trpc__ = createTRPCReact<AppRouter>());
